import Vue from 'vue'
import Router from 'vue-router'
// pages
/*
import AdminDashboardPage from '@/pages/admin-dashboard.vue'
*/
import ApplicantPage from '@/pages/applicant.vue'
import ApplicantsPage from '@/pages/applicants.vue'
import EmployerPage from '@/pages/employer.vue'
import AnnouncementsPage from '@/pages/announcements.vue'
import RegistrationPage from '@/pages/registration.vue'
import ForgotPasswordPage from '@/pages/forgot-password.vue'
import SetPasswordPage from '@/pages/set-password.vue'
import EmployersPage from '@/pages/employers.vue'
import LoginPage from '@/pages/login.vue'
import NewApplicantPage from '@/pages/new-applicant.vue'

import Datenschutz from '@/pages/imprint/datenschutz.vue'
import Impressum from '@/pages/imprint/impressum.vue'
import Nutzungsbedingungen from '@/pages/imprint/nutzungsbedingungen.vue'

import load_user from '@/utils/load-user'
import $shared from '@/shared'
import Parse from 'parse'

Vue.use(Router);

const routes = [
    {
        path: '/',
        redirect: {
            name: 'login',
        },
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: ForgotPasswordPage,
    },
    {
        path: '/set-password',
        name: 'set-password',
        component: SetPasswordPage,
    },
    {
        path: '/register/:token',
        name: 'register',
        component: RegistrationPage,
    },
    {
        path: '/employers',
        name: 'employers',
        component: EmployersPage,
    },
    /*
    {
        path: '/admin',
        name: 'admin-dashboard',
        component: AdminDashboardPage,
    },
    */
    {
        path: '/applicants/:id',
        name: 'applicant-with-id',
        component: ApplicantPage,
    },
    {
        path: '/applicants',
        name: 'applicants',
        component: ApplicantsPage,
    },
    {
        path: '/employers/:id',
        name: 'employer-with-id',
        component: EmployerPage,
    },
    {
        path: '/announcements',
        name: 'announcements',
        component: AnnouncementsPage,
    },
    {
        path: '/register',
        name: 'registration',
        component: RegistrationPage,
    },
    {
        path: '/new-applicant',
        name: 'new-applicant',
        component: NewApplicantPage,
    },
    {
        path: '/login',
        name: 'login',
        component: LoginPage,
    },
    {
        path: '/datenschutz',
        name: 'datenschutz',
        component: Datenschutz,
    },
    {
        path: '/impressum',
        name: 'impressum',
        component: Impressum,
    },
    {
        path: '/nutzungsbedingungen',
        name: 'nutzungsbedingungen',
        component: Nutzungsbedingungen,
    },
    {
        path: '/me',
        name: 'me',
        beforeEnter: (to, from, next) => {
            load_user().then((user) => {
                console.log(user);
                var route = (user.type == 'Employer') ? 'employer-with-id' : 'applicant-with-id';
                next({name: route, params: {id: user.profile.objectId}});
            }).catch((err) => {
                console.log(err);
                next({name: 'login'});
            });
        },
    },
    {
        path: '/logout',
        name: 'logout',
        beforeEnter: (to, from, next) => {
            Parse.User.logOut().then(() => {
                $shared.user.type = null;
                $shared.user.profile = null;
                $shared.user.vm = null;
                next({name: 'login'});
            });
        },
    },
];

const router = new Router({
    routes,
})
router.beforeEach((to, from, next) => {
    load_user().then(() => {
        next();
    }).catch(() => {
        if (to.name == "logout" || to.name == "datenschutz" || to.name == "impressum" || to.name == "nutzungsbedingungen" || to.name == "login" || to.name == "registration" || to.name == "forgot-password" || to.name == "set-password") {
            next();
        } else {
            next("/login");
        }
        
    });
})

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js